var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import classNames from 'classnames';
import React, { Component } from 'react';
import styles from './StyledLoadingBar.module.css';
var StyledLoadingBar = /** @class */ (function (_super) {
    __extends(StyledLoadingBar, _super);
    function StyledLoadingBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StyledLoadingBar.prototype.render = function () {
        var _a, _b;
        var inlineStyles = {
            width: this.props.width,
            animationDelay: this.props.noAnimation && this.props.fadeInDelay ? this.props.fadeInDelay + 'ms' : '0ms'
        };
        if (this.props.zIndex) {
            inlineStyles.zIndex = this.props.zIndex;
        }
        return (React.createElement("div", { className: classNames(styles.loadingBar, this.props.noAnimation ? styles.loadingBarInstant : styles.loadingBarAnimated, (_a = {}, _a[styles.submitVariant] = this.props.submitVariant, _a)), style: inlineStyles },
            React.createElement("div", { className: classNames(styles.bar, (_b = {}, _b[styles.submitVariant] = this.props.submitVariant, _b)) })));
    };
    return StyledLoadingBar;
}(Component));
export { StyledLoadingBar };
